import { Link, useNavigate } from "react-router-dom";
import { getRoleHome } from "../utils/navigation";
import NotificationBell from "./NotificationBell";

function initialsFor(displayName) {
  return displayName
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0])
    .join("")
    .toUpperCase() || "TC";
}

function workspaceTitle(accountType) {
  const type = String(accountType || "").toUpperCase();
  if (["SUPER_ADMIN", "ADMIN", "FINANCE", "SUPPORT", "OPERATIONS"].includes(type)) return "Operations Suite";
  if (type === "BUSINESS") return "Business Workspace";
  if (type === "SELLER") return "Merchant Workspace";
  if (type === "COURIER") return "Transporter Workspace";
  if (type === "BUYER") return "Buyer Workspace";
  return "TAZY Workspace";
}

export default function PortalTopbar({ user, onLogout }) {
  const navigate = useNavigate();
  const displayName = user?.display_name || user?.full_name || user?.email || "TAZY User";
  const accountType = user?.account_type || "PORTAL";
  const initials = initialsFor(displayName);
  const avatarSrc = user?.avatar_src || user?.profile_picture_src;

  function handleLogout() {
    if (typeof onLogout === "function") onLogout();
    navigate("/", { replace: true });
  }

  function openMyWorkspace() {
    navigate(getRoleHome(user));
  }

  return (
    <header className="portal-topbar-v2 refined-topbar professional-topbar clean-portal-topbar">
      <button type="button" className="topbar-title-block topbar-title-button" onClick={openMyWorkspace}>
        <span>TAZY PORTAL</span>
        <h1>{workspaceTitle(accountType)}</h1>
      </button>

      <div className="topbar-search refined-topbar-search" role="search">
        <span aria-hidden="true">⌕</span>
        <input placeholder="Search orders, products, sellers or couriers" />
      </div>

      <div className="topbar-actions refined-topbar-actions">
        <NotificationBell />
        <Link to="/" className="view-marketplace-btn public-site-link">Public site</Link>
        <div className="user-profile-chip refined-user-chip profile-aware-chip compact-user-chip">
          <div className="avatar-initials avatar-initials--image">
            {avatarSrc ? <img src={avatarSrc} alt={displayName} /> : <span>{initials}</span>}
          </div>
          <div className="user-chip-copy">
            <strong title={displayName}>{displayName}</strong>
            <span>{String(accountType).replaceAll("_", " ")}</span>
          </div>
          <button type="button" onClick={handleLogout}>Logout</button>
        </div>
      </div>
    </header>
  );
}
